export const HOME = {
  emergentLink: 'home-emergent-link'
};

export const AUTH = {
  loginEmail: 'auth-login-email',
  loginPwdField: 'auth-login-pwd-input',
  loginSubmit: 'auth-login-submit',
  registerName: 'auth-register-name',
  registerEmail: 'auth-register-email',
  registerPwdField: 'auth-register-pwd-input',
  registerSubmit: 'auth-register-submit'
};

export const DASHBOARD = {
  container: 'dashboard-container',
  newLeadsCard: 'dashboard-new-leads-card',
  hotLeadsCard: 'dashboard-hot-leads-card',
  followUpsCard: 'dashboard-followups-card',
  revenueCard: 'dashboard-revenue-card',
  missedFollowUpsCard: 'dashboard-missed-followups-card',
  serviceCard: 'dashboard-service-card',
  servicePie: 'dashboard-service-pie',
  pipelineFunnel: 'dashboard-pipeline-funnel'
};

export const LEADS = {
  container: 'leads-container',
  searchInput: 'leads-search-input',
  filterButton: 'leads-filter-button',
  createButton: 'leads-create-button',
  leadCard: 'lead-card',
  leadName: 'lead-name',
  leadStatus: 'lead-status',
  filterService: 'leads-filter-service',
  filterPriority: 'leads-filter-priority',
  filterStatus: 'leads-filter-status',
  filterSource: 'leads-filter-source',
  filterCity: 'leads-filter-city',
  filterProjectType: 'leads-filter-project-type',
  filterBudgetMin: 'leads-filter-budget-min',
  filterBudgetMax: 'leads-filter-budget-max',
  filterDateFrom: 'leads-filter-date-from',
  filterDateTo: 'leads-filter-date-to',
  filterReset: 'leads-filter-reset',
  filterAdvancedToggle: 'leads-filter-advanced-toggle'
};

export const SIDEBAR = {
  container: 'sidebar-container',
  dashboardLink: 'sidebar-dashboard-link',
  leadsLink: 'sidebar-leads-link',
  pipelineLink: 'sidebar-pipeline-link',
  calendarLink: 'sidebar-calendar-link',
  reportsLink: 'sidebar-reports-link',
  settingsLink: 'sidebar-settings-link',
  usersLink: 'sidebar-users-link',
  servicesLink: 'sidebar-services-link',
  rolesLink: 'sidebar-roles-link',
  notificationBell: 'sidebar-notification-bell',
  notificationBadge: 'sidebar-notification-badge',
  notificationDropdown: 'sidebar-notification-dropdown',
  globalSearch: 'sidebar-global-search'
};

export const PIPELINE = {
  container: 'pipeline-container',
  column: 'pipeline-column',
  card: 'pipeline-card'
};

export const SERVICES = {
  container: 'services-container',
  addBtn: 'add-service-btn',
  serviceCard: 'service-card',
  nameInput: 'service-name-input',
  descInput: 'service-desc-input',
  submitBtn: 'service-submit'
};

export const CALENDAR = {
  container: 'calendar-container',
  addFollowUpBtn: 'calendar-add-followup-btn',
  followUpItem: 'calendar-followup-item',
  snoozeBtn: 'calendar-snooze-btn',
  completeBtn: 'calendar-complete-btn'
};
